import React from "react"
import Navigation from "../navigation"
import styles from "./itmodseptheader.module.css"
import header from "./ITMOD_915virtual.png"

const ITModSeptHeader = (props) => {

    return (
        <div className={styles.container}>
            <Navigation 
                type="horizontal"
                items={[
                    {
                        title: "Upcoming Sessions",
                        url: "/#events",
                    },
                    {
                        title: "On-Demand Sessions",
                        url: "/on-demand",
                    },
                    
                    
                ]}
            />
            <img src={header} alt="SNG Live IT Modernization" className="deskHead" width="100%"/>
            <img src={header} alt="SNG Live IT Modernization" className="mobHead" width="100%"/>
            <div className={styles.hideme}>
                <h1 className={styles.title}>{props.title}</h1>
                <h1 className={styles.subTitle}>{props.subTitle}</h1>
                
            </div>
            
        </div>
    )
}

ITModSeptHeader.defaultProps = {
    title: `SNG Live - IT Modernization`,
    subTitle: `2020`
}
export default ITModSeptHeader